export default __webpack_public_path__ + "static/media/NoteAddIcon.5e622651.svg";